import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  static targets = ["message"]

  connect() {
    // Set up auto-dismiss for each message
    this.messageTargets.forEach((message, index) => {
      // Stagger the auto-dismiss slightly for multiple messages
      const delay = 5000 + (index * 100)
      setTimeout(() => {
        if (document.body.contains(message)) {
          this.animateOut(message)
        }
      }, delay)
    })
  }

  dismiss(event) {
    // Stop event propagation to prevent multiple triggers
    event.preventDefault()
    event.stopPropagation()
    
    // Find the closest message div
    const message = event.currentTarget.closest('[data-flash-target="message"]')
    if (message) {
      this.animateOut(message)
    }
  }

  animateOut(element) {
    // Prevent double-dismissal
    if (element.dataset.dismissing === "true") {
      return
    }
    element.dataset.dismissing = "true"
    
    element.classList.remove("animate-slide-in")
    element.classList.add("animate-slide-out")
    
    // Remove element after animation completes
    setTimeout(() => {
      element.remove()
    }, 300)
  }
}

